import { render, staticRenderFns } from "./InternationalPaymentGroup.vue?vue&type=template&id=eb2a47d0&"
import script from "./InternationalPaymentGroup.vue?vue&type=script&lang=js&"
export * from "./InternationalPaymentGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports